import { connect, MapStateToProps } from "react-redux";

import { isDarkTheme } from "@multiweb/reactCore/theme";
import { IAppState } from "@multiweb/types/react";
import { MenuScrollLayoutComponent, MenuScrollLayoutComponentProps, ThumbTheme } from "../MenuScrollLayoutComponent";

export type MenuScrollLayoutProps = Omit<MenuScrollLayoutComponentProps, "thumbTheme">;

type StateProps = Pick<MenuScrollLayoutComponentProps, "thumbTheme">;

const mapStateToProps: MapStateToProps<StateProps, MenuScrollLayoutProps, IAppState> = (state) => ({
    thumbTheme: isDarkTheme(state) ? ThumbTheme.light : ThumbTheme.dark,
});

export const MenuScrollLayout = connect(mapStateToProps, undefined, undefined, { forwardRef: true })(MenuScrollLayoutComponent);
